// extracted by mini-css-extract-plugin
module.exports = {"main":"D_n","darkMode":"D_cN"};